/* Titan Signs — product card enhancements:
   1) replaces the $0.01 penny-variant price with the real trade rate.
      Gate states (set by theme.liquid): TITAN_CUSTOMER = approved customer,
      TITAN_PENDING = signed in but awaiting approval. Non-approved visitors
      see a gate message instead of any price.
   2) hover overlay with material spec + best use cases (desktop)
   3) "More Info" button per card -> branded modal (uses / durability / options)
   Skips cart surfaces and the configurator page itself. */
(function () {
  "use strict";
  var GUEST = !window.TITAN_CUSTOMER;
  var PENDING = !!window.TITAN_PENDING;
  var GATE_TEXT = PENDING ? "Pricing unlocks on approval" : "Sign in for trade pricing";
  var INFO = {
    "coroplast-yard-signs": {
      price: "$39.60\u2013$30.00 /sheet", mat: "4mm & 10mm corrugated plastic, UV direct printed", best: "Yard signs · campaigns · real estate · events",
      desc: "Lightweight corrugated plastic that punches far above its price. Waterproof, weather-tolerant and UV direct printed — the workhorse for any short or medium-term campaign.",
      uses: ["Real estate & open house signs", "Yard & political campaign signs", "Event and directional signage", "Construction site signs", "Retail promotions"],
      env: ["Outdoor: 12–18 months, weather dependent", "Indoor: 2+ years"],
      opts: ["4mm or 10mm thickness", "Single or double-sided", "Grommets for hanging", "Standard & heavy-duty step stakes", "Gloss finish", "Contour / shape cut"]
    },
    "acrylic-photo-panels": {
      price: "$12.96 /sqft", mat: '3/16" acrylic, second-surface print, white underbase', best: "Lobby logos · photo displays · upscale interiors",
      desc: 'Crystal-clear 3/16" acrylic printed on the back surface with a white ink underbase — a glass-like depth and gloss that flat prints can\'t match.',
      uses: ["Lobby logo walls", "Gallery-style photo prints", "Upscale interior branding", "Recognition & award displays"],
      env: ["Indoor: 10+ years", "Short-term outdoor only — avoid direct sun long-term"],
      opts: ["Contour / shape cut", "Drill holes for standoff mounting", "Pairs with our standoff kits"]
    },
    "foam-board": {
      price: "$63.00\u2013$50.00 /sheet", mat: '3/16" smooth foam board', best: "Indoor displays · presentations · easel signs",
      desc: "Feather-light with a smooth matte face — the easiest board to transport, mount and display indoors.",
      uses: ["Presentations & meetings", "Easel-mounted event signs", "Wedding & party welcome signs", "Photo enlargements", "Trade show graphics"],
      env: ["Indoor: 2+ years", "Not rated for outdoor use"],
      opts: ["Single or double-sided", "Contour / shape cut"]
    },
    "pvc-board": {
      price: "$58.50\u2013$50.00 /sheet", mat: "3mm & 6mm expanded PVC, smooth finish", best: "Interior branding · menu boards · mid-term outdoor",
      desc: "Solid, smooth expanded PVC that routs and mounts cleanly. Sturdier than foam, lighter than metal — the all-rounder of rigid signage.",
      uses: ["Menu boards", "Interior wayfinding & branding", "Trade show panels", "Mid-term outdoor signs"],
      env: ["Outdoor: 3–5 years", "Indoor: 10+ years"],
      opts: ["3mm or 6mm thickness", "Single or double-sided", "Grommets", "Gloss finish", "Contour / shape cut", "Drill holes"]
    },
    "styrene": {
      price: "$49.50\u2013$40.00 /sheet", mat: '0.030" light, flexible plastic', best: "POP displays · insert panels · retail",
      desc: "Thin, bendable and tough — slides into frames and channel systems where rigid boards won't go.",
      uses: ["Point-of-purchase displays", "Sign frame inserts", "Retail shelf & counter signage"],
      env: ["Indoor: long-term", "Outdoor: short-term only"],
      opts: ["Single or double-sided", "Contour / shape cut"]
    },
    "aluminum-signs": {
      price: "From $7.77 /sqft", mat: '0.040" & 0.080" solid aluminum, gloss', best: "Parking · real estate · street signage",
      desc: "Solid aluminum with a glossy finish — rustproof, rigid and built for years of sun and weather. The standard for regulated and property signage.",
      uses: ["Parking & property signs", "Real estate frame panels", "Street & facility signage", "No trespassing / safety signs"],
      env: ["Outdoor: 7–10+ years", "Rustproof — never corrodes"],
      opts: ['0.040" or 0.080" thickness', "Single or double-sided", "Grommets / mounting holes", "Gloss finish", "Contour cut", "Drill holes"]
    },
    "aluminum-composite-acm": {
      price: "$144.00 /sheet", mat: "3mm & 6mm aluminum faces, poly core", best: "Building signs · long-term outdoor · architectural",
      desc: "Two aluminum faces bonded to a solid poly core — dead flat, lighter than solid metal, and the professional choice for building-mounted signage.",
      uses: ["Building & storefront signs", "Monument sign faces", "Architectural panels", "Long-term outdoor branding"],
      env: ["Outdoor: 5–10 years", "Stays flat — no oil-canning"],
      opts: ["3mm or 6mm thickness", "Single or double-sided", "Grommets", "Gloss finish", "Contour cut", "Drill holes"]
    },
    "backlit-polycarbonate": {
      price: "$3.60\u2013$3.00 /sqft", mat: '0.010" matte polycarbonate, backlit-tuned ink', best: "Lightboxes · illuminated cabinets · menu boards",
      desc: "Translucent polycarbonate printed with boosted ink density, so colors stay rich and saturated when the cabinet lights up.",
      uses: ["Illuminated sign cabinets", "Backlit menu boards", "Drive-thru panels", "Mall & airport lightboxes"],
      env: ["Indoor / in-cabinet: years of service", "Sized to your cabinet"],
      opts: ["Cut to your cabinet dimensions"]
    },
    "hd-vinyl-banner": {
      price: "$1.12\u2013$1.00 /sqft", mat: "13, 15 & 18oz vinyl — free hems & grommets", best: "Storefronts · events · grand openings · job sites",
      desc: "Premium vinyl scrim in three weights with welded hems and grommets included free. Finished exactly how the job needs it.",
      uses: ["Storefront & grand opening banners", "Event & sports banners", "Job site & fence banners", "Parades and festivals"],
      env: ["13oz: 1–3 years outdoor", "18oz: 3–5 years outdoor"],
      opts: ["13, 15 or 18oz weight", "Double-sided (18oz)", "Welded hems — included", "Grommets — included", "Rope, pole pockets, wind slits"]
    },
    "hdpe-banner": {
      price: "From $0.75 /sqft", mat: "Water & tear-resistant HDPE paper", best: "Short-term outdoor · fence runs · promos",
      desc: "Tear-resistant HDPE paper that shrugs off rain at a price that makes short campaigns painless.",
      uses: ["Short-term promotions", "Fence line runs", "Races & one-day events", "Seasonal sales"],
      env: ["Outdoor: up to ~6 months", "Indoor: 1+ year"],
      opts: ["Grommets for hanging"]
    },
    "mesh-banner": {
      price: "$2.19\u2013$0.99 /sqft", mat: "8oz mesh — free hems & grommets", best: "Fences · scaffolding · windy locations",
      desc: "Perforated mesh lets wind pass through instead of tearing the banner down — the only right answer for fences and scaffolding.",
      uses: ["Construction fence wraps", "Scaffolding banners", "Stadium & field fencing", "Windy outdoor sites"],
      env: ["Outdoor: 1–2 years", "37% air-flow perforation"],
      opts: ["Welded hems — included", "Grommets — included", "Pole pockets"]
    },
    "canvas-banner": {
      price: "From $2.49 /sqft", mat: "11oz poly-cotton canvas, gesso finish", best: "Gallery wraps · photo décor · interior art",
      desc: "Gallery-grade poly-cotton canvas with a gesso finish — made to be stretched, framed and hung somewhere it gets compliments.",
      uses: ["Stretched gallery wraps", "Photo & art reproduction", "Interior décor programs"],
      env: ["Indoor: decades", "Keep dry — interior use"],
      opts: ["Cut to size for stretching"]
    },
    "photo-paper-poster": {
      price: "From $1.00 /sqft", mat: "8mil bright white satin paper", best: "Retail campaigns · events · short-term promos",
      desc: "Bright white satin poster paper with crisp photographic detail — the budget pick for campaigns that change monthly.",
      uses: ["Retail campaign posters", "Event promotion", "Movie & concert style posters"],
      env: ["Indoor: 1+ year", "Outdoor: days to weeks"],
      opts: ["Cut to size"]
    },
    "no-curl-banner": {
      price: "From $2.00 /sqft", mat: "8mil no-edge-curl material, lays dead flat", best: "Retractable stands · hanging displays",
      desc: "Engineered to hang dead flat with zero edge curl — what you want inside a retractable stand or on a hanging display.",
      uses: ["Retractable banner stands", "Hanging ceiling displays", "Trade show back walls"],
      env: ["Indoor: years of service", "Rolls and re-rolls without curling"],
      opts: ["Cut to your stand size", "Pairs with our banner stand"]
    },
    "vehicle-magnets": {
      price: "$0.063 /sq in", mat: "30mil vehicle-grade magnetic", best: "Car doors · fleet branding · removable ads",
      desc: "Thick 30mil vehicle-grade magnet with vivid printing — brand the truck by day, pull it off in the driveway at night.",
      uses: ["Car & truck door signs", "Fleet branding without commitment", "Contractor vehicle ID"],
      env: ["Vehicle-rated for highway speeds", "Remove and clean weekly for paint safety"],
      opts: ["Custom sizes 2×3 to 96×24 inches", "Contour cut", "Rounded corners"]
    },
    "step-stakes-50ct-box": { mat: '9-gauge 10"×30" wire stakes, 50/box', best: "Pairs with 4mm coroplast yard signs" },
    "heavy-duty-step-stakes-25ct-box": { mat: "Reinforced wire stakes, 25/box", best: "Large or 10mm double-thick signs" },
    "standoffs-50ct-box": { mat: "Aluminum standoff kits, anchors + screws", best: "Acrylic · PVC · ACM panel mounting" },
    "titan-sample-kit": { mat: "Unbranded swatch of every material", best: "Show customers · close bigger jobs" },
    "adjustable-banner-stand": { mat: "Retractable stand with steel feet", best: "Retail promos · events · lobbies" }
  };
  var PENNY = /^\s*(From\s+)?\$0\.01(\s+USD)?\s*$/;
  var MONEY = /^\s*(From\s+)?\$[\d,]+(\.\d+)?(\s*[\u2013-]\s*\$[\d,]+(\.\d+)?)?(\s*\/\s*(sq\s?ft|sqft|sq\s?in|sheet))?\s*$/i;

  var css = document.createElement("style");
  css.textContent =
    ".titan-hover-card{position:relative;overflow:hidden}" +
    ".titan-hover{position:absolute;left:0;right:0;bottom:0;z-index:3;pointer-events:none;" +
    "background:rgba(13,13,15,.92);color:#fff;padding:14px 16px;opacity:0;transform:translateY(8px);" +
    "transition:opacity .18s ease,transform .18s ease;border-top:3px solid #d81b28;text-align:left}" +
    ".titan-hover .th-mat{font-size:12.5px;line-height:1.45;color:#e6e6ea;margin:0}" +
    ".titan-hover .th-best{font-size:11.5px;font-weight:700;color:#ff8b94;margin:7px 0 0;text-transform:uppercase;letter-spacing:.04em}" +
    ".titan-hover .th-best b{color:#fff}" +
    "@media (hover:hover){.titan-hover-card:hover .titan-hover{opacity:1;transform:translateY(0)}}" +
    ".titan-mi-btn{position:absolute;top:10px;right:10px;z-index:4;background:rgba(13,13,15,.85);color:#fff;" +
    "border:1px solid rgba(255,255,255,.25);border-radius:999px;padding:6px 14px;font-size:11px;font-weight:800;" +
    "letter-spacing:.05em;text-transform:uppercase;cursor:pointer;line-height:1}" +
    ".titan-mi-btn:hover{background:#d81b28;border-color:#d81b28}" +
    ".titan-modal-backdrop{position:fixed;inset:0;background:rgba(0,0,0,.62);z-index:9998;display:flex;align-items:center;justify-content:center;padding:20px}" +
    ".titan-modal{background:#fff;border-radius:12px;max-width:880px;width:100%;max-height:88vh;overflow:auto;box-shadow:0 24px 80px rgba(0,0,0,.4)}" +
    ".titan-modal-head{position:sticky;top:0;background:#0d0d0f;color:#fff;display:flex;align-items:center;justify-content:space-between;" +
    "padding:14px 22px;border-bottom:3px solid #d81b28}" +
    ".titan-modal-head h3{margin:0;font-size:15px;font-weight:800;letter-spacing:.06em;text-transform:uppercase}" +
    ".titan-modal-x{background:none;border:none;color:#fff;font-size:24px;cursor:pointer;line-height:1;padding:2px 6px}" +
    ".titan-modal-x:hover{color:#ff2d3d}" +
    ".titan-modal-body{display:grid;grid-template-columns:1.1fr 1fr;gap:26px;padding:24px}" +
    "@media(max-width:700px){.titan-modal-body{grid-template-columns:1fr}}" +
    ".titan-modal-body h4{margin:0 0 8px;font-size:12px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:#d81b28}" +
    ".titan-modal-desc{font-size:14.5px;line-height:1.6;color:#333;margin:0 0 14px}" +
    ".titan-modal-price{font-size:20px;font-weight:900;color:#d81b28;margin:0 0 16px}" +
    ".titan-modal ul{margin:0 0 18px;padding-left:18px}" +
    ".titan-modal li{font-size:13.5px;line-height:1.7;color:#3d3d44}" +
    ".titan-modal-cta{display:inline-block;background:#d81b28;color:#fff;font-weight:800;font-size:14px;" +
    "padding:13px 26px;border-radius:8px;text-decoration:none}" +
    ".titan-modal-cta:hover{background:#ff2d3d;color:#fff}";
  document.head.appendChild(css);

  function handleFrom(el) {
    var scope = el;
    for (var i = 0; i < 8 && scope; i++) {
      var link = scope.querySelector && scope.querySelector('a[href*="/products/"]');
      if (!link && scope.matches && scope.matches('a[href*="/products/"]')) link = scope;
      if (link) {
        var m = link.getAttribute("href").match(/\/products\/([a-z0-9-]+)/);
        if (m) return m[1];
      }
      scope = scope.parentElement;
    }
    return null;
  }

  /* ---------- modal ---------- */
  var backdrop = null;
  function closeModal() {
    if (backdrop) { backdrop.remove(); backdrop = null; document.body.style.overflow = ""; }
  }
  function openModal(handle) {
    var info = INFO[handle];
    if (!info || !info.desc) return;
    closeModal();
    backdrop = document.createElement("div");
    backdrop.className = "titan-modal-backdrop";
    var modal = document.createElement("div");
    modal.className = "titan-modal";

    var head = document.createElement("div");
    head.className = "titan-modal-head";
    var title = document.createElement("h3");
    title.textContent = "More Information — " + (info.name || handle.replace(/-/g, " ").replace(/\b\w/g, function (c) { return c.toUpperCase(); }));
    var x = document.createElement("button");
    x.className = "titan-modal-x";
    x.setAttribute("aria-label", "Close");
    x.innerHTML = "&times;";
    x.addEventListener("click", closeModal);
    head.appendChild(title);
    head.appendChild(x);

    var body = document.createElement("div");
    body.className = "titan-modal-body";

    var left = document.createElement("div");
    var desc = document.createElement("p");
    desc.className = "titan-modal-desc";
    desc.textContent = info.desc;
    var price = document.createElement("p");
    price.className = "titan-modal-price";
    price.textContent = GUEST ? GATE_TEXT : info.price;
    var cta = document.createElement("a");
    cta.className = "titan-modal-cta";
    if (GUEST && PENDING) {
      cta.href = "/account";
      cta.textContent = "Account Pending Review";
    } else if (GUEST) {
      cta.href = "/pages/trade-account-application";
      cta.textContent = "Apply for a Trade Account →";
    } else {
      cta.href = "/products/" + handle;
      cta.textContent = "Configure & Order →";
    }
    left.appendChild(desc);
    left.appendChild(price);
    left.appendChild(cta);

    var right = document.createElement("div");
    function section(label, items) {
      if (!items || !items.length) return;
      var h = document.createElement("h4");
      h.textContent = label;
      var ul = document.createElement("ul");
      items.forEach(function (t) {
        var li = document.createElement("li");
        li.textContent = t;
        ul.appendChild(li);
      });
      right.appendChild(h);
      right.appendChild(ul);
    }
    section("Common Uses", info.uses);
    section("Durability", info.env);
    section("Options", info.opts);

    body.appendChild(left);
    body.appendChild(right);
    modal.appendChild(head);
    modal.appendChild(body);
    backdrop.appendChild(modal);
    backdrop.addEventListener("click", function (e) { if (e.target === backdrop) closeModal(); });
    document.body.appendChild(backdrop);
    document.body.style.overflow = "hidden";
  }
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeModal(); });

  /* ---------- card enhancements ---------- */
  function patchPrices(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) {
      var n = walker.currentNode;
      if (PENNY.test(n.nodeValue) || (GUEST && MONEY.test(n.nodeValue))) nodes.push(n);
    }
    nodes.forEach(function (n) {
      if (n.__titanDone) return;
      var el = n.parentElement;
      if (!el) return;
      if (el.closest('[class*="cart"], [id*="cart"], cart-drawer, cart-items')) return;
      if (el.closest("#titan-configurator")) return;
      if (el.closest(".titan-modal")) return;
      var h = handleFrom(el);
      if (!h) { if (PENNY.test(n.nodeValue)) el.style.visibility = "hidden"; return; }
      if (GUEST) {
        n.nodeValue = GATE_TEXT;
        n.__titanDone = true;
        el.style.color = "#d81b28";
        el.style.fontWeight = "700";
      } else if (INFO[h] && INFO[h].price && PENNY.test(n.nodeValue)) {
        n.nodeValue = INFO[h].price;
        n.__titanDone = true;
        el.style.color = "#d81b28";
        el.style.fontWeight = "700";
      } else if (PENNY.test(n.nodeValue)) {
        el.style.visibility = "hidden";
      }
    });
  }

  function cardRoot(link) {
    return link.closest("li") || link.closest('[class*="card"]') || link.closest("product-card") || link.parentElement;
  }

  function addHovers(root) {
    var links = root.querySelectorAll('a[href*="/products/"]');
    links.forEach(function (link) {
      if (link.closest(".titan-home") || link.closest("#titan-configurator")) return;
      if (link.closest('[class*="cart"], [id*="cart"], cart-drawer, cart-items, header, nav')) return;
      var m = link.getAttribute("href").match(/\/products\/([a-z0-9-]+)/);
      if (!m || !INFO[m[1]]) return;
      var card = cardRoot(link);
      if (!card || card.dataset.titanHover) return;
      var rect = card.getBoundingClientRect();
      if (rect.height < 120 || rect.width < 120) return;
      card.dataset.titanHover = "1";
      card.classList.add("titan-hover-card");
      var handle = m[1];
      var info = INFO[handle];

      var ov = document.createElement("div");
      ov.className = "titan-hover";
      var mat = document.createElement("p");
      mat.className = "th-mat";
      mat.textContent = info.mat;
      var best = document.createElement("p");
      best.className = "th-best";
      best.innerHTML = "<b>Best for:</b> ";
      best.appendChild(document.createTextNode(info.best));
      ov.appendChild(mat);
      ov.appendChild(best);
      card.appendChild(ov);

      if (info.desc) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "titan-mi-btn";
        btn.textContent = "More Info";
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          openModal(handle);
        });
        card.appendChild(btn);
      }
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      patchPrices(document.body);
      addHovers(document.body);
    });
  }

  function start() {
    patchPrices(document.body);
    addHovers(document.body);
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
